import type { AgentId } from '../../types/anna';

export const voiceSuggestions: string[] = [
  'Zet het licht in de woonkamer op 40%',
  'Wat wacht er op mij?',
  'Hoe wordt het weer?',
  'Stuur Bakker dat het donderdag wordt',
  'Doe de voordeur open',
  'Wat ben je aan het doen?',
];

export const summonExamples: { id: string; agent: AgentId; title: string; line: string }[] = [
  { id: 'vandaag', agent: 'agenda', title: 'Vandaag', line: '10:00 stand-up · 14:00 Lisa' },
  { id: 'vannacht', agent: 'code', title: 'Vannacht gedaan', line: 'Build gerepareerd · PR #142' },
  { id: 'koffie', agent: 'huis', title: 'Koffie staat aan', line: 'Klaar over 3 min' },
  { id: 'regen', agent: 'initiatief', title: 'Regen vanaf 13:00', line: 'Neem een paraplu mee' },
];
